<template>
  <div>
    <Dialog v-model:visible="visible" modal :closable="false" :header="`Document Part: ${partId} ${title}`" :style="{ width: '50vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <div class="flex flex-col">
        <div class="overflow-auto max-h-[70vh]">
          <TuiViewer :initial-value="content" height="100%" />
        </div>
      </div>
      <template #footer>
        <Button label="Close" severity="secondary" @click="visible = false" autofocus />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
  import Dialog from 'primevue/dialog';
  import Button from 'primevue/button';
  import TuiViewer from '@/components/Editors/TuiViewer.vue';
  import { ref, watch } from 'vue';

  const props = defineProps({
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    partId: {
      type: String,
      default: '',
    },
  });

  const emit = defineEmits(['close']);
  const visible = ref(false);

  watch(
    () => props.open,
    (newValue) => {
      visible.value = newValue;
    },
  );

  watch(
    () => visible.value,
    (newValue) => {
      if (!newValue) {
        emit('close');
      }
    },
  );
</script> 